import { render, staticRenderFns } from "./ManutencaoItem.vue?vue&type=template&id=28142f27&"
import script from "./ManutencaoItem.vue?vue&type=script&lang=js&"
export * from "./ManutencaoItem.vue?vue&type=script&lang=js&"
import style0 from "./ManutencaoItem.vue?vue&type=style&index=0&id=28142f27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports